export default __webpack_public_path__ + "static/media/register.037ccf55.png";